import Grid2 from "@mui/material/Grid2";

import { masterDetailsMinHeight, pageBgColor } from "@/utils/theme";
import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { RollsetRoll } from "../../models/Rollset";
import { getRollsetRolls } from "../../repositories/RollsetRepository";
import { TableRollset } from "./components/TableRollset";

type useRollsetRollsProps = {
	sectionId: number;
	standId: number;
	letter: string;
};

export const useRollsetRolls = ({
	sectionId,
	standId,
	letter,
}: useRollsetRollsProps) => {
	return useQuery<RollsetRoll[], Error>({
		queryKey: ["rollsetRolls", sectionId, standId, letter],
		queryFn: ({ signal }) => {
			if (!sectionId || !standId) {
				return [];
			}
			return getRollsetRolls(
				{
					sectionId,
					standId,
					letter,
				},
				signal,
			);
		},
	});
};

export const RollsetPage = () => {
	return (
		<>
			<HelmetDexteel title="Rollsets" />
			<Grid2 size={{ md: 12, xs: 12 }} sx={{ backgroundColor: pageBgColor }}>
				<TableRollset />
			</Grid2>
		</>
	);
};
